export interface CreatorAccountCellProps {
  name: string;
  email?: string;
  phone?: string;
}

const normalizeSystemLabel = (value?: string) => {
  if (!value) return value;
  const trimmed = value.trim();
  if (!trimmed) return trimmed;
  if (trimmed.toLowerCase() === 'system') return 'Sistem';
  return trimmed;
};

const resolveCreatorName = (creator: any) => {
  if (!creator || typeof creator !== 'object') return undefined;
  const nameParts = [`${creator.firstName ?? ''} ${creator.lastName ?? ''}`.trim()];
  if (creator.fullName) {
    nameParts.push(String(creator.fullName));
  }
  if (creator.name) {
    nameParts.push(String(creator.name));
  }
  if (creator.email) {
    nameParts.push(String(creator.email));
  }
  if (creator.id !== undefined && creator.id !== null) {
    nameParts.push(String(creator.id));
  }
  const resolved = nameParts.find((value) => value && value.trim());
  return normalizeSystemLabel(resolved);
};

const normalizeFallbackName = (record: any) => {
  if (!record) return undefined;
  if (record.createdByName) return normalizeSystemLabel(String(record.createdByName));
  if (record.createdByEmail) return normalizeSystemLabel(String(record.createdByEmail));
  if (record.createdBy) return normalizeSystemLabel(String(record.createdBy));
  return undefined;
};

export const getCreatorAccountCellProps = (record: any): CreatorAccountCellProps => {
  const creator =
    record?.createdByAccount || record?.createdByUser || record?.createdByInfo;

  if (creator && typeof creator === 'object') {
    const name = resolveCreatorName(creator) ?? 'Sistem';
    const email = creator.email ?? undefined;
    const phone = creator.phoneNumber || creator.phone || undefined;
    return { name, email, phone };
  }

  const fallbackName = normalizeFallbackName(record);
  return {
    name: fallbackName && fallbackName.trim() ? fallbackName.trim() : 'Sistem',
    email: record?.createdByEmail || undefined,
  };
};

export const getAssigneAccountCellProps = (record: any): CreatorAccountCellProps => {
  const creator =
    record?.account;

  if (creator && typeof creator === 'object') {
    const name = resolveCreatorName(creator) ?? 'Sistem';
    const email = creator.email ?? undefined;
    const phone = creator.phoneNumber || creator.phone || undefined;
    return { name, email, phone };
  }

  const fallbackName = normalizeFallbackName(record);
  return {
    name: fallbackName && fallbackName.trim() ? fallbackName.trim() : 'Sistem',
    email: record?.createdByEmail || undefined,
  };
};
